import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import router from './router'
import axios from 'axios';
import Vuelidate from 'vuelidate'
import swal from 'sweetalert';
import JsonCSV from 'vue-json-csv'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false
Vue.use(Vuelidate)

library.add(faArrowUp, faArrowDown)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('downloadCsv', JsonCSV)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  });
} else {
  console.debug('Not configuring Sentry, environment is', process.env.NODE_ENV)
}

// axios.defaults.baseURL = 'http://127.0.0.1:8000/api/';
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/';
Vue.prototype.$http = axios;
Vue.prototype.axios = axios;
Vue.prototype.$appName = 'Regina'
const  accessToken = localStorage.getItem('access_token')

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (401 === error.response.status) {
      swal({
          title: "Session Expired",
          text: "Your session has expired. Redirecting to a login page.",
          icon: "warning",
          // showCancelButton: true,
          // confirmButtonColor: "#DD6B55",
          button: "OK",
          closeModal: false
      }).then(() => {
        store.dispatch('logout')
          .then(() => router.push({name: 'login'}))
          .catch(err => console.log(err))
      });
  } else {
      return Promise.reject(error);
  }
});

if (accessToken) {
  axios.defaults.headers.common['Authorization'] = 'JWT ' + accessToken  
}
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
